export const customLocationName = 'ตำแหน่งหมุด - Pin Location'
